module.exports = __webpack_public_path__ + "img/logo.59e2ead4.svg";